import { Link } from 'react-router-dom';

const cols = [
  {
    heading: 'Platform',
    links: [
      { label: 'Features',            href: '/features' },
      { label: 'Case Precedents',     href: '/case-precedents' },
      { label: 'Report an Incident',  href: '/report-incident' },
      { label: 'Sign In',             href: '/accounts/login' },
      { label: 'Register',            href: '/accounts/register' },
    ],
  },
  {
    heading: 'Organisation',
    links: [
      { label: 'About WITS',    href: '/about-us' },
      { label: 'Get Involved',  href: '/get-involved' },
      { label: 'FAQs',          href: '/faqs' },
      { label: 'Contact Us',    href: '/contact-us' },
      { label: 'LAPA Africa',   href: 'https://lapa.africa', external: true },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy Policy',  href: '#' },
      { label: 'Terms of Use',    href: '#' },
      { label: 'Cookie Policy',   href: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#052e16] text-white" style={{ fontFamily: 'var(--font-body)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 lg:pt-20 pb-8">

        {/* Main grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">

          {/* Brand */}
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img src="/ICON2.png" alt="WITS" className="h-10 w-auto" />
              <span
                className="text-sm font-bold tracking-widest uppercase"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                WITS
              </span>
            </div>

            <p className="text-white/45 text-sm leading-relaxed mb-6 max-w-xs">
              Empowering wildlife conservation through data-driven intelligence.
              A{' '}
              <a
                href="https://lapa.africa"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white transition-colors underline underline-offset-2"
              >
                LAPA Africa
              </a>{' '}
              initiative.
            </p>

            <div className="space-y-1.5 text-sm text-white/40">
              <p>+254 716 152699</p>
              <p>info@lapa.africa</p>
              <p>Nairobi, Kenya</p>
            </div>
          </div>

          {/* Link columns */}
          {cols.map((col) => (
            <div key={col.heading}>
              <h4 className="text-[10px] tracking-[0.18em] uppercase text-white/35 font-semibold mb-5">
                {col.heading}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) =>
                  'external' in link && link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-white/55 hover:text-white transition-colors inline-flex items-center gap-1"
                      >
                        {link.label}
                        <span className="text-[10px] text-white/30">↗</span>
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-white/55 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-7 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-white/25 text-xs">
            © {new Date().getFullYear()} WITS — Wildlife Information &amp; Tracking System.
            All rights reserved.
          </p>
          <p className="text-white/20 text-xs">
            Built to protect what cannot speak for itself.
          </p>
        </div>
      </div>
    </footer>
  );
}
